import useValidator from '../../../utilities/useValidator';
import validators from '../../../utilities/validators';

const validator = (hasLTA: boolean) =>
    validators.compose(
        validators.requiredBoolean('setting.isStateHidden'),
        validators.requiredString('setting.functionality'),
        validators.only(
            () => hasLTA,
            validators.compose(
                validators.requiredValue('lta.ownerIdType'),
                validators.requiredString('lta.ownerId'),
                validators.requiredString('lta.registrationNumber'),
                validators.requiredNumber('lta.omv'),
                validators.requiredDate('lta.originalRegistrationDate'),
                validators.requiredNumber('lta.arf'),
                validators.requiredDate('lta.coeExpiryDate'),
                validators.requiredNumber('lta.coe')
            )
        ),
        validators.only(
            values => hasLTA && values.isLTAUploaded,
            validators.compose(
                validators.requiredValue('lta.ownerIdType'),
                validators.requiredString('lta.ownerId'),
                validators.requiredString('lta.make'),
                validators.requiredString('lta.model'),
                validators.requiredString('lta.registrationNumber'),
                validators.requiredString('lta.engineNumber'),
                validators.requiredString('lta.chassisNumber'),
                validators.requiredNumber('lta.omv'),
                validators.requiredDate('lta.originalRegistrationDate'),
                validators.requiredDate('lta.firstRegistrationDate'),
                validators.requiredNumber('lta.transfers'),
                validators.requiredNumber('lta.arf'),
                validators.requiredNumber('lta.parfRebateAmount'),
                validators.requiredValue('lta.coeCategory'),
                validators.requiredNumber('lta.coePeriod'),
                validators.requiredDate('lta.coeExpiryDate'),
                validators.requiredNumber('lta.coe')
            )
        )
    );

const useFinderVehicleValidator = (hasLTA: boolean) => useValidator(validator(hasLTA));

export default useFinderVehicleValidator;
